import { useCallback, useMemo, useState } from 'react';

export const TASK_ATTACHMENT_TILE_OVERLAY_RADIUS = 12;

export function useTaskAttachmentTile({ href, title, isImage, ext, onPreviewImage, onOpenFile }) {
    const [hovered, setHovered] = useState(false);

    const label = useMemo(() => {
        if (title) return title;
        if (ext) return `${String(ext).toUpperCase()} file`;
        return 'Attachment';
    }, [ext, title]);

    const canInteract = Boolean(href);

    const handleOpen = useCallback(() => {
        if (!href) return;
        if (isImage) onPreviewImage?.(href);
        else onOpenFile?.(href);
    }, [href, isImage, onOpenFile, onPreviewImage]);

    const onMouseEnter = useCallback(() => setHovered(true), []);
    const onMouseLeave = useCallback(() => setHovered(false), []);

    const onKeyDown = useCallback(
        (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleOpen();
            }
        },
        [handleOpen],
    );

    return {
        hovered,
        setHovered,
        label,
        canInteract,
        handleOpen,
        onMouseEnter,
        onMouseLeave,
        onKeyDown,
    };
}

